module.exports = __webpack_public_path__ + "static/img/img3.6aae245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partnerLogo/img3.png
// module id = SV9o
// module chunks = 1